import template from './sw-cms-block-product-finder.html.twig';

const { Component } = Shopware;

Component.register('sw-cms-block-product-finder', {
    template
});